import React = require("react");
import { LimaIconProps } from "./DefLimaIconType";

export const LimaIconToolsActs = ({
  size = 32, // or any default size of your choice
  color = "black", // or any color of your choice
  title = "", //title
}: LimaIconProps): JSX.Element => {
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   viewBox="0 0 24 24"
    //   width={size} // added size here
    //   height={size} // added size here
    //   fill={color} // added color here
    //   aria-labelledby="title"
    // >
    //   <title id="title">{title}</title>
    //   <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" />
    //   <path d="M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0z" />
    // </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 34.074"
      width={size} // added size here
      height={size} // added size here
      fill={color} // added color here
      aria-labelledby="title"
    >
      <title id="title">{title}</title>
      <g id="Acts" transform="translate(-291.57 -83.634)">
        <rect
          id="Rectangle_24139"
          data-name="Rectangle 24139"
          width="32"
          height="32"
          transform="translate(291.57 84.384)"
          fill="none"
        />
        <g id="Group_13268" data-name="Group 13268" transform="translate(-73.236 -296.328)">
          <path
            id="Path_9026"
            data-name="Path 9026"
            d="M373.891,410.018h-1.683a2.348,2.348,0,0,1-2.348-2.348V383.06a2.348,2.348,0,0,1,2.348-2.348h19.544v29.306h-12.1"
            fill="none"
            stroke="#8e8e93"
            strokeWidth="1.5"
          />
          <path
            id="Path_9027"
            data-name="Path 9027"
            d="M373.613,421.49H372.16a2.3,2.3,0,0,1-2.3-2.3v-3.16a2.3,2.3,0,0,1,2.3-2.3h19.592v7.76h-11.43"
            transform="translate(0 -11.471)"
            fill="none"
            stroke="#8e8e93"
            strokeWidth="1.5"
          />
          <path
            id="Path_9028"
            data-name="Path 9028"
            d="M376.037,420.4v7.069l2.847-1.681,2.913,1.746V420.4Z"
            transform="translate(-2.146 -14.82)"
            fill="none"
            stroke="#8e8e93"
            strokeWidth="1.5"
          />
          <line
            id="Line_406"
            data-name="Line 406"
            x2="7.299"
            transform="translate(373.121 405.578)"
            fill="none"
            stroke="#8e8e93"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
          <line
            id="Line_407"
            data-name="Line 407"
            x2="5.809"
            transform="translate(385.943 405.578)"
            fill="none"
            stroke="#8e8e93"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
          <g id="Group_13268-2" data-name="Group 13268" transform="translate(372.125 384.307)">
            <rect
              id="Rectangle_24187"
              data-name="Rectangle 24187"
              width="7.604"
              height="4.955"
              transform="matrix(0.501, -0.865, 0.865, 0.501, 0.782, 7.033)"
              fill="none"
              stroke="#8e8e93"
              strokeWidth="1.5"
            />
            <path
              id="Rectangle_24188"
              data-name="Rectangle 24188"
              d="M0,0H2.727a0,0,0,0,1,0,0V9.759a1.363,1.363,0,0,1-1.363,1.363h0A1.363,1.363,0,0,1,0,9.759V0A0,0,0,0,1,0,0Z"
              transform="translate(6.292 7.407) rotate(-59.909)"
              fill="none"
              stroke="#8e8e93"
              strokeWidth="1.5"
            />
            <line
              id="Line_408"
              data-name="Line 408"
              x2="5.76"
              y2="3.338"
              transform="translate(3.813)"
              fill="none"
              stroke="#8e8e93"
              strokeLinecap="round"
              strokeWidth="1.5"
            />
            <line
              id="Line_409"
              data-name="Line 409"
              x2="5.76"
              y2="3.338"
              transform="translate(0 6.579)"
              fill="none"
              stroke="#8e8e93"
              strokeLinecap="round"
              strokeWidth="1.5"
            />
            <line
              id="Line_410"
              data-name="Line 410"
              y1="3.689"
              x2="2.138"
              transform="translate(13.143 8.576)"
              fill="none"
              stroke="#8e8e93"
              strokeLinecap="round"
              strokeWidth="1.5"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
